import {
  ButtonHTMLAttributes,
  ComponentPropsWithRef,
  ComponentType,
  FunctionComponent,
} from "react";
import clsx from "clsx";

import Loading from "../Loading/Loading";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  leadingIcon?: ComponentType<ComponentPropsWithRef<"svg">>;
  trailingIcon?: ComponentType<ComponentPropsWithRef<"svg">>;
  accent?: "neutral" | "primary" | "destructive" | "green";
  icon?: boolean;
  loading?: boolean;
  pill?: boolean;
  rounded?: boolean;
  textSize?: "sm" | "md";
}
const CustomButton: FunctionComponent<ButtonProps> = ({
  leadingIcon: LeadingIcon,
  trailingIcon: TrailingIcon,
  accent,
  children,
  className,
  disabled,
  loading,
  pill,
  rounded,
  textSize = "md",
  ...htmlButtonAttributes
}) => {
  return (
    <button
      {...htmlButtonAttributes}
      disabled={disabled}
      className={clsx(
        className,
        "tw-inline-flex tw-items-center tw-gap-2 tw-shrink-0 tw-py-2 tw-px-6 tw-border-solid tw-border tw-font-medium focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-offset-1",
        { "tw-text-sm": textSize === "sm", "tw-text-base": textSize === "md" },
        accent === "neutral" &&
          "tw-border-gray-300 tw-text-gray-700 tw-bg-white hover:tw-bg-gray-50 focus-visible:tw-ring-indigo-500",
        accent === "primary" &&
          "tw-border-transparent tw-text-white tw-bg-indigo-800 hover:tw-bg-indigo-900 focus-visible:tw-ring-indigo-500",
        accent === "destructive" &&
          "tw-border-transparent tw-text-white tw-bg-red-600 hover:tw-bg-red-700 focus-visible:tw-ring-red-500",
        accent === "green" &&
          "tw-border-transparent tw-text-white tw-bg-green-600 hover:tw-bg-green-700 focus-visible:tw-ring-green-500",
        rounded && "tw-rounded-full",
        pill ? "tw-rounded-full" : "tw-rounded",
        disabled && "tw-cursor-not-allowed tw-opacity-50",
      )}
    >
      {LeadingIcon && <LeadingIcon className="-tw-ml-1 tw-h-5 tw-w-5" aria-hidden="true" />}
      {children}
      {TrailingIcon && <TrailingIcon className="-tw-mr-1 tw-h-5 tw-w-5" aria-hidden="true" />}
      {loading && <Loading className="-tw-mr-1 tw-h-5 tw-w-5 tw-text-white" />}
    </button>
  );
};

CustomButton.defaultProps = {
  accent: "neutral",
};

export default CustomButton;
